






































import { Component, Vue, Prop } from 'vue-property-decorator';

import { ResponseCodeEnum, DeliveryDateModel, TireStoringContract, TotalRemain, Utils } from '@/models';

import DeliveryDate from '@/components/delivery/DeliveryDate.vue';

// component
// @ts-ignore
import FunctionalCalendar from '@/components/calendar/FucntionCalendar.vue';
// service
import { tireStoringContractService, settingService, vehicleService } from '@/services';
import { Moment } from 'moment';

@Component({
    components: {
        FunctionalCalendar,
        DeliveryDate,
    },
})
export default class PickUpCalendar extends Vue {
  @Prop() private isChooseDate!: boolean;
  private items: DeliveryDateModel[] = [];
  private currentDate: Date = this.$moment().toDate();
  private monthNames: string[] = [];
  private preDisabledState: boolean = false;
  private nextDisabledState: boolean = false;
  private dateTop: string = '';
  private total: number = 0;
  private dayNames: string[] = [];
  private lstHoliday: Moment[] = [];

  private async created() {
    this.monthNames = this.$moment.months();
    this.dayNames = Utils.DATE_PICKER_LANG.days;
    this.preDisabledState = true;
    await settingService.get()
    .then((res) => {
      if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
        this.total = res.data.data.quantily;
      }
    });
    this.getListHoliday().then((res) => this.lstHoliday = res);
  }

  private getListHoliday(): Promise<Moment[]> {
    return new Promise((resolve, reject) => {
      vehicleService.getAllHoliday()
        .then((res: any) => {
          const lstDate: Moment[] = [];
          res.data.data.forEach((item: any) => {
            lstDate.push(this.$moment(item));
          });
          resolve(lstDate);
        });
    });
  }
  private getAllDateOfWeek(startOfWeek: any) {
    this.items = [];
    const endOfWeek = startOfWeek.clone().add(13, 'd');
    vehicleService.getTotalPickupSetRemain(startOfWeek.format("YYYY-MM-DD"), endOfWeek.format("YYYY-MM-DD"))
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.items = [];
          res.data.data.forEach((remain: TotalRemain, index) => {
            const currentDate = this.$moment(remain.date);
            const dateDeadline = this.$moment(remain.dateDeadlineWarehouse).toDate();
            this.items.push(new DeliveryDateModel({
              dateNumber: currentDate.format("DD"),
              date: currentDate,
              totalDelivery: remain.total,
              isDelivery: false,
              id: index,
              isWorkOff: remain.isWorkOff,
              isAfter11h: remain.isAfter11h,
              dateDeadlineWarehouse: dateDeadline
            }));
          });
        }
      });
  }

  private preMonth() {
    const crrDate = this.$moment().startOf('month');
    const preTemp = this.$moment().diff(this.$moment((this.$refs.Calendar as any).listCalendars[0].date), 'month');
    if(preTemp >= 0 || preTemp < -2) {
      this.preDisabledState = true;
    } else {
      if(preTemp < 0 || preTemp >= 1) {
        this.nextDisabledState = false;
      }
      this.preDisabledState = false;
    }
    (this.$refs.Calendar as any).PreMonth();
  }

  private nextMonth() {
    const crrDate = this.$moment().startOf('month');
    const nextTemp = this.$moment().diff(this.$moment((this.$refs.Calendar as any).listCalendars[0].date), 'month');
    if (nextTemp !== 0) {
      this.nextDisabledState = true;
    } else {
      if(nextTemp < -3 || nextTemp >= 0) {
        this.preDisabledState = false;
      }
      this.nextDisabledState = false;
    }
    (this.$refs.Calendar as any).NextMonth();
  }

  private changeDate(data: any) {
    this.getDateTop();
    const date = !data.selectedDate ? this.currentDate : data.selectedDate;
    this.currentDate = date;
    this.items = [];
    this.getAllDateOfWeek(this.$moment(date, 'DD/MM/YYYY'));
    this.getListHoliday().then((res) => {
      (this.$refs.Calendar as any).pushVal([], res);
    });
  }

  private getDateTop() {
    if (this.$refs.Calendar as any) {
      (this.$refs.Calendar as any).listCalendars.forEach((element: any, index: number) => {
          (this.$refs.Calendar as any).listCalendars[index].dateTop = 
          this.$moment()
            .year((this.$refs.Calendar as any).listCalendars[index].date.getFullYear())
            .month((this.$refs.Calendar as any).listCalendars[index].date.getMonth())
          .format('YYYY 年 MMM');
      });
    }
  }

  private clickDate(date: Date) {
    this.$emit('input', date);
  }

  private goBack() {
    this.$emit('close');
  }
}
